import { getProvidersData } from '../../../helpers/data-helper';

export default {
	data: function() {
		return {
			provider: "",
			provider_data: [],
			rank: 0
		}
	},
	watch: {
	    $route: function(new_val, old_val) {
	    	if(new_val) {
	    		this.init();
	    	}
	    }
	},
	mounted: function(){
		this.init();
	},
	methods: {
		init: function () {
			this.provider = this.$route.params.provider;

			let data = getProvidersData();
			this.provider_data = data[this.provider];
			
			this.getRank(data);

			analytics.page({type: 'page', name: 'Reviews_'+this.provider, path: 'Reviews_'+this.provider}, {integrations: {'AdWords': false}});
		},
		getRank: function(data) {
			let keys =[];
			for(var key in data) {
				keys.push(key);
			}

			let vm = this;
			this.rank = keys.findIndex(function(key) {
				return vm.provider == key;
			})
		},
		back: function () {
			window.history.back();
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/Reviews/Adt/adt.js